<template>
    <div>
        <!-- <select-box-modal
            v-if="isModal1"
            :selectList="options1"
            :selectedIndex="innerSelectedIndex1"
            :title="'서류 목록'"
            @closeModal="closeModal1"
  
        /> -->
        <!-- <select-box-modal         
            v-if="isModal2"
            :selectList="options2"
            :selectedIndex="innerSelectedIndex2"
            :title="'발행된 서류'"
            @closeModal="closeModal2"
            
        />
        <select-box-modal
            v-if="isModal3"
            :selectList="options3"
            :selectedIndex="innerSelectedIndex3"
            :title="'발행된 서류'"
            @closeModal="closeModal3"
            
        />
    -->
        <!-- <div name="select-box" class="select-box" style="margin-bottom: 8px;" @click="openModal1">
            <span>{{selectedText1}}</span>
            <img style="width: 13px;" src="../../assets/bottom_arrow.png" />
        </div> -->
        <Tab 
            :list="options1"
            :selectedIndex="selectedIndex"
            @select="selectTab"
            style="margin-bottom: 17px;"
        />
        <list-buttons 
            :list="options2"
            :selectedIndex="innerSelectedIndex2"
            v-show="innerSelectedIndex1 === 0"
            @select="closeModal2"
        />
        <list-buttons 
            :list="options3"
            :selectedIndex="innerSelectedIndex3"
            v-show="innerSelectedIndex1 === 1"
            @select="closeModal3"
        />
        <!-- <div name="select-box" class="select-box" @click="openModal2" v-if="innerSelectedIndex1 === 0">
            <span>{{selectedText2}}</span>
            <img style="width: 13px;" src="../../assets/bottom_arrow.png" />
        </div>
        <div name="select-box" class="select-box" @click="openModal3" v-if="innerSelectedIndex1 === 1">
            <span>{{selectedText3}}</span>
            <img style="width: 13px;" src="../../assets/bottom_arrow.png" />
        </div> -->
    </div>
</template>

<script>
import SelectBoxModal from '@/components/modals/SelectBoxModal2';
import Tab from '@/components/molecules/Tab';
import ListButtons from '@/components/molecules/ListButtons';

export default {   
    name: 'twoSelectBox',
    props: ['options1', 'options2', 'options3', 'selectedIndex'],
    components: {SelectBoxModal, Tab, ListButtons},
    data: function()
    {
        return {
            selectedText1: '',
            selectedText2: '',
            selectedText3: '',
            isModal1: false,
            isModal2: false,
            isModal3: false,
            innerSelectedIndex1: 0,
            innerSelectedIndex2: 0,
            innerSelectedIndex3: 0,
            selectedType: 0
        }
    },
    mounted: function()
    {
        this.innerSelectedIndex1 = this.selectedIndex;
        if(this.selectedIndex !== -1)
        {
            this.selectedText1 = this.options1[this.selectedIndex]; 
        }

        if(this.innerSelectedIndex1 === 0)
        {
            this.selectedText2 = this.options2[this.innerSelectedIndex2]; 
        }
        else
        {
            this.selectedText3 = this.options3[this.innerSelectedIndex3]; 
        }
    },
    methods: {
        selectTab: function(selected)
        {
            this.innerSelectedIndex1 = selected;
            this.innerSelectedIndex2 = 0;
            this.innerSelectedIndex3 = 0;
            if(selected !== -1)
            {              
                this.selectedText1 = this.options1[this.innerSelectedIndex1];                
            }

            // if(this.innerSelectedIndex1 === 0)
            // {
            //     this.selectedText2 = this.options2[this.innerSelectedIndex2]; 
            // }
            // else
            // {
            //     this.selectedText3 = this.options3[this.innerSelectedIndex3]; 
            // }


            this.isModal1 = false;
            
            this.$emit('select', this.innerSelectedIndex1, this.innerSelectedIndex2, this.innerSelectedIndex3);
        },
        closeModal1: function(selected)
        {
            this.innerSelectedIndex1 = selected;
            if(selected !== -1)
            {              
                this.selectedText1 = this.options1[this.innerSelectedIndex1];                
            }

            if(this.innerSelectedIndex1 === 0)
            {
                this.selectedText2 = this.options2[this.innerSelectedIndex2]; 
            }
            else
            {
                this.selectedText3 = this.options3[this.innerSelectedIndex3]; 
            }


            this.isModal1 = false;
            
            this.$emit('select', this.innerSelectedIndex1, this.innerSelectedIndex2, this.innerSelectedIndex3);
        },
        closeModal2: function(selected)
        {
            this.innerSelectedIndex2 = selected;
            if(selected !== -1)
            {              
                this.selectedText2 = this.options2[this.innerSelectedIndex2];                
            }
            this.isModal2 = false;
            
            this.$emit('select', this.innerSelectedIndex1, this.innerSelectedIndex2, this.innerSelectedIndex3);
        },
        closeModal3: function(selected)
        {
            this.innerSelectedIndex3 = selected;
            if(selected !== -1)
            {              
                this.selectedText3 = this.options3[this.innerSelectedIndex3];                
            }
            this.isModal3 = false;
            
            this.$emit('select', this.innerSelectedIndex1, this.innerSelectedIndex2, this.innerSelectedIndex3);
        },
        openModal1: function()
        {
            this.isModal1 = true;
        },
        openModal2: function()
        {
            this.isModal2 = true;
        },
        openModal3: function()
        {
            this.isModal3 = true;
        }
    }
}
</script>

<style scoped>
 .select-box {
        width: 100%;
        height: 49px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-sub-color1, #F3F5F8);
        color: var(--Gray-50, #000);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 14px 0 20px;
        box-sizing: border-box;
    }
</style>    


// WEBPACK FOOTER //
// src/components/atoms/TwoSelectBox.vue